"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var store_1 = require("../../store");
var Icon_1 = __importDefault(require("../Icon"));
var FormatText_1 = __importDefault(require("../FormatText"));
var Button = function (props) {
    var icon = props.icon, responsive = props.responsive, confirm = props.confirm, children = props.children, title = props.title, onClick = props.onClick, okText = props.okText, cancelText = props.cancelText, rest = __rest(props, ["icon", "responsive", "confirm", "children", "title", "onClick", "okText", "cancelText"]);
    var isMobile = store_1.useStore(function (state) { return state.ui.isMobile; });
    var showTitle = !responsive || !isMobile;
    var handleClick = function (e) {
        if (!onClick)
            return;
        if (!confirm) {
            onClick(e);
            return;
        }
        var confirmMsg = typeof confirm === 'string' ? confirm : 'ui.messages.delete.confirm';
        antd_1.Modal.confirm({
            title: react_1.default.createElement(FormatText_1.default, { id: confirmMsg }),
            onOk: function () {
                onClick(e);
            },
            okText: react_1.default.createElement(FormatText_1.default, { id: okText || 'ui.commons.ok' }),
            cancelText: react_1.default.createElement(FormatText_1.default, { id: cancelText || 'ui.commons.cancel' }),
        });
    };
    return (react_1.default.createElement(antd_1.Button, __assign({}, rest, { onClick: handleClick }),
        icon && react_1.default.createElement(Icon_1.default, { name: icon }),
        showTitle && (title || children)));
};
exports.default = Button;
